import { render, staticRenderFns } from "./selectTheInspector.vue?vue&type=template&id=2b5b858c&scoped=true&"
import script from "./selectTheInspector.vue?vue&type=script&lang=js&"
export * from "./selectTheInspector.vue?vue&type=script&lang=js&"
import style0 from "./selectTheInspector.vue?vue&type=style&index=0&id=2b5b858c&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5b858c",
  null
  
)

export default component.exports